import {Deal, BasketInputItem, BasketItemType} from "@irati/types"
import authentication from "@irati/auth"
import Screen from "../enum/Screen"
import basketService from "../../../services/basket"
import checkoutService from "../../../services/checkout"
import {Details} from ".."

export default async function handleNoProduct(deal: Deal): Promise<Details> {
  const userId = authentication.user().uuid

  const basketItem: BasketInputItem = {
    entityId: deal.uuid,
    entityType: BasketItemType.Deal, // this will never be a reward/FlexiReward
    targetUserId: userId,
    // 'count' and 'noProduct' fields are required by the BE to be able to create the redemption without a product
    count: 1,
    noProduct: true
  }
  await basketService.updateBasket({items: [basketItem], userId})

  const checkout = await checkoutService.startCheckout(userId)
  const completeCheckout = await checkoutService.completeCheckout(checkout.uuid)
  const redemptionId = completeCheckout.fullRedemptions[0].uuid
  return {screen: Screen.DealSuccess, deal, checkoutId: checkout.uuid, redemptionId}
}

export function isNoProduct(deal: Deal) {
  const dealProducts = deal.productConfig?.products || []
  return dealProducts.length === 0
}
